import type { ReactElement, ReactNode } from 'react';
import { createContext, useContext, type Dispatch, type SetStateAction } from 'react';
import { useControllableState } from '../util/use-controllable-state.tsx';
import { Join } from './join.tsx';

export type ToggleGroupContextType = [
    selected: string | undefined,
    setSelected: Dispatch<SetStateAction<string | undefined>>,
];

export const ToggleGroupContext = createContext<ToggleGroupContextType>(['', () => {}]);

export function useToggleGroup(): ToggleGroupContextType {
    return useContext(ToggleGroupContext);
}

export type ToggleGroupProps = {
    children?: ReactNode;
    className?: string;
    defaultSelected?: string;
    join?: boolean;
    onSelectedChange?: (value: string | undefined) => void;
    selected?: string;
};

export function ToggleGroup({
    children,
    defaultSelected,
    join = true,
    onSelectedChange,
    selected,
    ...props
}: ToggleGroupProps): ReactElement {
    const state = useControllableState({
        defaultValue: defaultSelected,
        value: selected,
        onChange: onSelectedChange,
    });
    if (join) {
        return (
            <Join {...props}>
                <ToggleGroupContext.Provider value={state}>{children}</ToggleGroupContext.Provider>
            </Join>
        );
    }
    return <ToggleGroupContext.Provider value={state}>{children}</ToggleGroupContext.Provider>;
}
